var _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUpArrow = function SvgUpArrow(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12043",
    "data-name": "Group 12043",
    transform: "translate(-371 -61.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    transform: "translate(371 61.592)",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M380.278,91.752l5.9-5.9,5.9,5.9",
    transform: "translate(-2.813 -15.207)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpArrow, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI1IDI1Ij4KICA8ZyBpZD0iR3JvdXBfMTIwNDMiIGRhdGEtbmFtZT0iR3JvdXAgMTIwNDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNzEgLTYxLjU5MikiPgogICAgPGcgaWQ9IkVsbGlwc2VfMjA2IiBkYXRhLW5hbWU9IkVsbGlwc2UgMjA2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNzEgNjEuNTkyKSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjEiIG9wYWNpdHk9IjAuMjIiPgogICAgICA8Y2lyY2xlIGN4PSIxMi41IiBjeT0iMTIuNSIgcj0iMTIuNSIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxjaXJjbGUgY3g9IjEyLjUiIGN5PSIxMi41IiByPSIxMiIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPHBhdGggaWQ9IlBhdGhfMTI0OCIgZGF0YS1uYW1lPSJQYXRoIDEyNDgiIGQ9Ik0zODAuMjc4LDkxLjc1Mmw1LjktNS45LDUuOSw1LjkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yLjgxMyAtMTUuMjA3KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };